import { ChangeDetectionStrategy, Component, inject, input, Input, OnInit } from '@angular/core';
import { StateComponent } from '../../../../../../../../../components/state/state.component';
import { IDropdownConfig } from '../../model/betting.model';
import { FormsModule, ReactiveFormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BettingTypeKey } from '@oogaday/shared';
import { MultiVal } from '../../../../../../../../../model/common.model';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatError, MatFormField, MatHint, MatLabel } from '@angular/material/form-field';


@Component({
  selector: 'oo-dropdowns-betting',
  templateUrl: './dropdowns-betting.component.html',
  styleUrls: ['./dropdowns-betting.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatFormField, MatLabel, MatSelect, FormsModule, ReactiveFormsModule, MatOption, MatHint, MatError],
})
export class DropdownsBettingComponent<T> extends StateComponent<DropdownsBettingComponentState> implements OnInit {

  readonly bettingForm = input.required<UntypedFormGroup>();
  readonly key = input.required<BettingTypeKey>();
  readonly initValue = input.required<string | number | MultiVal | string[] | string[][] | undefined | T>();
  state: DropdownsBettingComponentState = {
    multipleDropdowns: false,
    dropdowns: [],
    form: null!,
    multi: false,
    numOfSelections: undefined,
  };
  private readonly fb = inject(UntypedFormBuilder);

  @Input() set multipleDropdowns(multipleDropdowns: boolean) {
    this.updateState({ multipleDropdowns });
  }

  @Input() set dropdowns(dropdowns: IDropdownConfig[]) {
    this.updateState({ dropdowns });
  }

  @Input() set multi(multi: boolean) {
    this.updateState({ multi });
  }

  @Input() set numOfSelections(numOfSelections: number) {
    this.updateState({ numOfSelections });
  }

  ngOnInit(): void {
    this.initForm();
  }

  isOptionDisabled(index: number, val: string | number): boolean {
    if (!this.state.numOfSelections) {
      return false;
    }

    let values: (string | number)[];

    if (this.state.form instanceof UntypedFormArray) {
      values = (this.state.form as UntypedFormArray).at(index)!.value;
    } else {
      values = (this.state.form as UntypedFormControl).value;
    }

    if (values?.includes(val)) {
      return false;
    }

    return values?.length >= this.state.numOfSelections;
  }

  private initForm(): void {
    if (this.state.dropdowns.length === 1 && !this.state.multipleDropdowns) {
      this.updateState({
        form: this.fb.control(this.initValue() ?? (this.state.multi ? [] : null), [Validators.required]),
      });
    } else {
      this.updateState({
        form: this.fb.array(this.state.dropdowns.map((dropdown, index) =>
          this.fb.control((this.initValue() as string[][])?.[index] ?? (this.state.multi ? [] : null), [Validators.required]))),
      });
    }

    this.bettingForm().addControl(this.key(), this.state.form);
    this.detectChangesAfterTick();
  }
}

interface DropdownsBettingComponentState {
  dropdowns: IDropdownConfig[];
  form: UntypedFormArray | UntypedFormControl;
  multi: boolean;
  numOfSelections: number | undefined;
  multipleDropdowns: boolean;
}
